import React, { useId } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';
import { FOOTER_PLATFORM, FOOTER_COMPANY, FOOTER_LEGAL, isExternal } from '../nav/routes';
type IconProps = React.SVGProps<SVGSVGElement>;
const YouTubeIcon = (props: IconProps) => <svg viewBox="0 0 24 24" aria-hidden="true" {...props} data-id="element-81" data-mp="36oy0x9h17x22">
    <path fill="#FF0000" d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814Z" data-id="element-82" data-mp="36nd5ziqt2c3o" />
    <path fill="#FFFFFF" d="M9.545 15.568V8.432L15.818 12l-6.273 3.568Z" data-id="element-83" data-mp="3qcnhekjiqavz" />
  </svg>;
const InstagramIcon = (props: IconProps) => {
  const gradId = useId();
  return <svg viewBox="0 0 24 24" aria-hidden="true" {...props} data-id="element-84" data-mp="2ey9wnok2abk6">
      <defs data-id="element-85" data-mp="2ezl3xycpu1g1">
        <radialGradient id={gradId} cx="30%" cy="107%" r="150%" data-id="element-86" data-mp="2ew70snw89o7j">
          <stop offset="0%" stopColor="#FEDA75" data-id="element-87" data-mp="3labp9pa6nun7" />
          <stop offset="25%" stopColor="#FA7E1E" data-id="element-88" data-mp="3gah0br9yxf4s" />
          <stop offset="50%" stopColor="#D62976" data-id="element-89" data-mp="3gbqyeggtmnbf" />
          <stop offset="75%" stopColor="#962FBF" data-id="element-90" data-mp="3v7q2zh4q25bt" />
          <stop offset="100%" stopColor="#4F5BD5" data-id="element-91" data-mp="3v9b11gq8w6ef" />
        </radialGradient>
      </defs>
      <g fill={`url(#${gradId})`} data-id="element-92" data-mp="3q7lr64erdyrx">
        <path d="M12 2.16c3.2 0 3.58.01 4.85.07 1.17.05 1.8.25 2.23.41.56.22.96.48 1.38.9.42.42.68.82.9 1.38.16.42.36 1.06.41 2.23.06 1.27.07 1.65.07 4.85s-.01 3.58-.07 4.85c-.05 1.17-.25 1.8-.41 2.23-.22.56-.48.96-.9 1.38-.42.42-.82.68-1.38.9-.42.16-1.06.36-2.23.41-1.27.06-1.65.07-4.85.07s-3.58-.01-4.85-.07c-1.17-.05-1.8-.25-2.23-.41a3.7 3.7 0 0 1-1.38-.9 3.7 3.7 0 0 1-.9-1.38c-.16-.42-.36-1.06-.41-2.23-.06-1.27-.07-1.65-.07-4.85s.01-3.58.07-4.85c.05-1.17.25-1.8.41-2.23.22-.56.48-.96.9-1.38.42-.42.82-.68 1.38-.9.42-.16 1.06-.36 2.23-.41C8.42 2.17 8.8 2.16 12 2.16ZM12 0C8.74 0 8.33.01 7.05.07 5.78.13 4.9.33 4.14.63c-.79.3-1.46.72-2.12 1.38A5.86 5.86 0 0 0 .63 4.14c-.3.76-.5 1.64-.56 2.91C.01 8.33 0 8.74 0 12s.01 3.67.07 4.95c.06 1.27.26 2.15.56 2.91.3.79.72 1.46 1.38 2.12.66.66 1.33 1.08 2.12 1.38.76.3 1.64.5 2.91.56C8.33 23.99 8.74 24 12 24s3.67-.01 4.95-.07c1.27-.06 2.15-.26 2.91-.56a5.86 5.86 0 0 0 2.12-1.38 5.86 5.86 0 0 0 1.38-2.12c.3-.76.5-1.64.56-2.91.06-1.28.07-1.69.07-4.95s-.01-3.67-.07-4.95c-.06-1.27-.26-2.15-.56-2.91a5.86 5.86 0 0 0-1.38-2.12A5.86 5.86 0 0 0 19.86.63c-.76-.3-1.64-.5-2.91-.56C15.67.01 15.26 0 12 0Z" data-id="element-93" data-mp="3qaq0fg72zkpg" />
        <path d="M12 5.84A6.16 6.16 0 1 0 18.16 12 6.16 6.16 0 0 0 12 5.84Zm0 10.16A4 4 0 1 1 16 12a4 4 0 0 1-4 4Z" data-id="element-94" data-mp="1hjw90asbso8t" />
        <circle cx="18.41" cy="5.59" r="1.44" data-id="element-95" data-mp="1ml3gs9ugxnfh" />
      </g>
    </svg>;
};
const FacebookIcon = (props: IconProps) => <svg viewBox="0 0 24 24" aria-hidden="true" {...props} data-id="element-96" data-mp="1rid49jyarp0o">
    <path fill="#1877F2" d="M24 12.07C24 5.4 18.63 0 12 0S0 5.4 0 12.07C0 18.1 4.39 23.1 10.13 24v-8.44H7.08v-3.49h3.05V9.41c0-3.02 1.79-4.69 4.53-4.69 1.31 0 2.69.24 2.69.24v2.97h-1.52c-1.49 0-1.96.93-1.96 1.89v2.25h3.33l-.53 3.49h-2.8V24C19.61 23.1 24 18.1 24 12.07Z" data-id="element-97" data-mp="3oboq3o2u9xl9" />
  </svg>;
const TikTokIcon = (props: IconProps) => <svg viewBox="0 0 24 24" aria-hidden="true" {...props} data-id="element-98" data-mp="25n3x49xzkwsu">
    <path fill="#25F4EE" d="M9.875 9.45v-.96a6.99 6.99 0 0 0-.96-.07A6.93 6.93 0 0 0 5 20.97a6.93 6.93 0 0 1 4.875-11.52Z" data-id="element-99" data-mp="21m0ifqrod6t7" />
    <path fill="#FE2C55" d="M19.61 5.84a4.02 4.02 0 0 1-1-.09 4.04 4.04 0 0 0 3.39 2.27v-.96a4.04 4.04 0 0 1-2.39-1.22ZM14.27 17.04a3.16 3.16 0 0 1-3.15-2.99v.96a3.16 3.16 0 0 0 4.74 2.73 3.16 3.16 0 0 1-1.59-.7Z" data-id="element-100" data-mp="1wpjv2ysauwh6" />
    <path fill="#FFFFFF" d="M16.6 5.94a4.04 4.04 0 0 1-1-.1 4.04 4.04 0 0 0 3.39 2.18v2.27a6.4 6.4 0 0 1-3.75-1.21v5.49a4.85 4.85 0 1 1-4.85-4.85c.32 0 .65.03.96.09v2.4a2.45 2.45 0 0 0-.96-.19 2.45 2.45 0 1 0 2.45 2.45V2.5h2.34a4.04 4.04 0 0 0 .06.74 4.04 4.04 0 0 0 1.31 2.7Z" data-id="element-101" data-mp="2kdb5fwua4zft" />
  </svg>;
const XIcon = (props: IconProps) => <svg viewBox="0 0 24 24" aria-hidden="true" {...props} data-id="element-102" data-mp="13y9wso1w4ze0">
    <path fill="#FFFFFF" d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24h-6.66l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231 5.45-6.231Zm-1.161 17.52h1.833L7.084 4.126H5.117L17.083 19.77Z" data-id="element-103" data-mp="2rvzlfa75dzs4" />
  </svg>;
const socials = [{
  name: 'YouTube',
  Icon: YouTubeIcon,
  url: 'https://www.youtube.com/@blinkblis_'
}, {
  name: 'Instagram',
  Icon: InstagramIcon,
  url: 'https://www.instagram.com/blinkblis/'
}, {
  name: 'Facebook',
  Icon: FacebookIcon,
  url: 'https://www.facebook.com/profile.php?id=61556583863470'
}, {
  name: 'TikTok',
  Icon: TikTokIcon,
  url: 'https://www.tiktok.com/@blinkblis_'
}, {
  name: 'X',
  Icon: XIcon,
  url: 'https://x.com/blinkblis'
}];
const PATHS: Record<string, (string | null)[]> = {
  platform: FOOTER_PLATFORM,
  company: FOOTER_COMPANY,
  legal: FOOTER_LEGAL
};
const linkClass = 'text-white/50 hover:text-white text-[15px] md:text-sm transition-colors block py-1 md:py-0';
function FooterLinks({
  group
}: {
  group: 'platform' | 'company' | 'legal';
}) {
  const {
    t
  } = useLanguage();
  const labels = t(`footer.links.${group}`) as string[];
  const paths = PATHS[group];
  return <ul className="space-y-3 md:space-y-4" data-id="element-104" data-mp="1im34oeo0thfp">
      {labels.map((label, i) => {
      const path = paths[i];
      if (!path) return null;
      return <li key={label} data-id="element-105" data-mp="1rnsw3khwkgdh" data-mpi={i}>
            {isExternal(path) ? <a href={path} className={linkClass} data-id="element-106" data-mp="1rlgex9jyya1h">
                {label}
              </a> : <Link to={path} className={linkClass} data-id="element-107" data-mp="13vm1aprtshg6">
                {label}
              </Link>}
          </li>;
    })}
    </ul>;
}
export function Footer() {
  const currentYear = new Date().getFullYear();
  const {
    t
  } = useLanguage();
  return <footer className="py-12 md:py-16 relative z-10 border-t border-white/5 bg-background" data-id="element-108" data-mp="18viad3fdqz2l">
      <div className="max-w-7xl mx-auto px-5 sm:px-6" data-id="element-109" data-mp="l5w98afg69ry">
        <div className="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-5 gap-10 md:gap-12 mb-12 md:mb-16" data-id="element-110" data-mp="g8nsme9y6dst">
          <div className="col-span-1 md:col-span-2 lg:col-span-2" data-id="element-111" data-mp="2gb5fvuwx3nnh">
            <Link to="/" className="inline-flex items-center gap-3 md:gap-4 bg-transparent p-0 mb-4 md:mb-5" data-id="element-112" data-mp="2g8sx5fjc599d">
              <img src="https://cdn.magicpatterns.com/uploads/w8wf8HrNFmFRNJWrke4AoT/blinkblis-navbar-mark-transparent-512.png" alt="Blinkblis" className="block h-10 w-10 md:h-14 md:w-14 shrink-0 object-contain" data-id="element-113" data-mp="2q1hwxd5iwyov" />
              <span className="text-white text-[22px] md:text-2xl font-semibold tracking-[-0.02em]" data-id="element-114" data-mp="22aci91bbkcg5">
                Blinkblis
              </span>
            </Link>
            <p className="text-white/40 text-[15px] md:text-sm max-w-xs font-light leading-relaxed" data-id="element-115" data-mp="27cbl8a35d7ck">
              {t('footer.desc')}
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 col-span-1 md:col-span-2 lg:col-span-3 gap-8 md:gap-12" data-id="element-116" data-mp="3ioch08yfhw1t">
            <div data-id="element-117" data-mp="3mowc76zfyplb">
              <h4 className="text-white font-medium mb-4 md:mb-6 text-[15px] md:text-base" data-id="element-118" data-mp="3msk7aakjbk25">
                {t('footer.platform')}
              </h4>
              <FooterLinks group="platform" data-id="element-119" data-mp="172tqyh8q0a58" />
            </div>

            <div data-id="element-120" data-mp="12asil6eob3kh">
              <h4 className="text-white font-medium mb-4 md:mb-6 text-[15px] md:text-base" data-id="element-121" data-mp="12a8zhmdae94v">
                {t('footer.company')}
              </h4>
              <FooterLinks group="company" data-id="element-122" data-mp="x9v1yy9bahl3" />
            </div>

            <div className="col-span-2 md:col-span-1" data-id="element-123" data-mp="sdxiwk6nyx4m">
              <h4 className="text-white font-medium mb-4 md:mb-6 text-[15px] md:text-base" data-id="element-124" data-mp="ndrnqu16qshs">
                {t('footer.legal')}
              </h4>
              <FooterLinks group="legal" data-id="element-125" data-mp="jczei0sbcnli" />
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-126" data-mp="ee4y15htjb4k">
          <div className="flex items-center justify-center gap-3 order-1 md:order-2 w-full md:w-auto" data-id="element-127" data-mp="2dow7hy6em1io">
            {socials.map(({
            name,
            Icon,
            url
          }) => <a key={name} href={url} target="_blank" rel="noopener noreferrer" aria-label={`Blinkblis on ${name}`} className="group w-[44px] h-[44px] md:w-10 md:h-10 rounded-full flex items-center justify-center bg-white/5 border border-white/10 md:hover:border-white/20 md:hover:bg-white/[0.07] focus:outline-none focus:ring-2 focus:ring-accent/50 transition-all duration-300" data-id="element-128" data-mp="1hm0l0nx3e9qi">
                <Icon className="w-[20px] h-[20px] md:w-[18px] md:h-[18px] transition-transform duration-300 md:group-hover:scale-105" data-id="element-129" data-mp="12wm8x824te7f" />
              </a>)}
          </div>
          <p className="text-white/30 text-[13px] md:text-xs font-light order-2 md:order-1 text-center md:text-left w-full md:w-auto" data-id="element-130" data-mp="ozftnngm9xmy">
            &copy; {currentYear} {t('footer.rights')}
          </p>
        </div>
      </div>
    </footer>;
}